import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountResponse, AccountUpdateRequest } from '../models/account.model';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/services/api.service';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private readonly baseUrl = `${environment.apiUrl}/api/SystemUser`;
  private readonly apiService = inject(ApiService);

  getAccountById(id: number): Observable<AccountResponse> {
    return this.apiService.get<AccountResponse>(`${this.baseUrl}/GetAccountById?id=${id}`);
  }

  updateAccount(body: AccountUpdateRequest): Observable<AccountResponse> {
    return this.apiService.post<AccountResponse>(`${this.baseUrl}/UpdateAccount`, body);
  }
}
